import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ExpenseItemDetailPage } from './expense-item-detail';

@NgModule({
  declarations: [
    ExpenseItemDetailPage,
  ],
  imports: [
    IonicPageModule.forChild(ExpenseItemDetailPage),
  ],
})
export class ExpenseItemDetailPageModule {}



// WEBPACK FOOTER //
// ./src/pages/expense-item-detail/expense-item-detail.module.ts